import Landing from './routes/landing';
import GetStyled from './routes/get-styled';
import Product from './routes/product';
import Cart from './routes/cart';
import Checkout from './routes/checkout';
import PurchaseOutfit from './routes/purchase-outfit';
import Account from './routes/account';
import SavedOutfits from './routes/saved-outfits';
import SavedProducts from './routes/saved-products';
import Onboarding from './routes/onboarding';
import Training from './routes/training';
import Outfits from './routes/outfits';
import Quiz from './routes/quiz';

export default [
    Product,
    Landing,
    PurchaseOutfit,
    GetStyled,
    Cart,
    Checkout,
    Account,
    SavedProducts,
    SavedOutfits,
    Onboarding,
    Training,
    Outfits,
    Quiz,
]
